module.exports = __webpack_public_path__ + "static/media/cctv.49144647.png";